export default "__VITE_ASSET__edc2ab65__"